// extracted by mini-css-extract-plugin
export default {"wrapper":"UserMenu_wrapper__Nitr2","email":"UserMenu_email__AMEqa","btn":"UserMenu_btn__jwxED"};